import { render, staticRenderFns } from "./TemplateName.vue?vue&type=template&id=ca746654&scoped=true"
import script from "./TemplateName.vue?vue&type=script&lang=js"
export * from "./TemplateName.vue?vue&type=script&lang=js"
import style0 from "./TemplateName.vue?vue&type=style&index=0&id=ca746654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca746654",
  null
  
)

export default component.exports